import { Trans, useTranslation } from "react-i18next";
import { WELCOME_VISITORS_URL } from "@/lib";
import i18n from "@/i18n/config";
import { createFileRoute } from "@tanstack/react-router";
import { useBuildingAdminOrReceptionistAccess } from "@/hooks/useReceptionistAccess";
import ReceptionView from "@/components/ReceptionView";
import {
  buildingPreregistrationsOptions,
  buildingVisitorsOptions,
} from "@/api";
import { useRouterStore } from "@/store/zustandStore";
import { useBuildingQuery } from "@/components/RouterSetup";
import { useBuildingWelcomeVisitAccess } from "@/hooks/useBuildingWelcomeVisitAccess";

export const Route = createFileRoute("/_portal/building/visitors/")({
  component: BuildingVisitors,
  loader: () => {
    const { queryClient } = useRouterStore.getState();
    if (!queryClient) return;
    queryClient.ensureQueryData(buildingVisitorsOptions());
    queryClient.ensureQueryData(buildingPreregistrationsOptions());
  },
});

function BuildingVisitors() {
  const { t } = useTranslation();
  const { allowBuildingAdminOrReceptionistAccess } =
    useBuildingAdminOrReceptionistAccess();
  const { isLoading: isLoadingBuildingVisitors, data: visitors } =
    useBuildingQuery(buildingVisitorsOptions());
  const { isLoading: isLoadingPreregistrations, data: preregistrationGroups } =
    useBuildingQuery(buildingPreregistrationsOptions());
  const hasWelcomeVisit = useBuildingWelcomeVisitAccess();

  if (!allowBuildingAdminOrReceptionistAccess || !hasWelcomeVisit) {
    return null;
  }
  return (
    <>
      <div className="pageHeader">
        <h1>{t("PAGES.BUILDING_VISITORS.HEADER")}</h1>
        <p>
          <Trans i18nKey="PAGES.BUILDING_VISITORS.SUBHEADER">
            Text
            <a href={WELCOME_VISITORS_URL(i18n.language)} target="_blank"></a>.
          </Trans>
        </p>
      </div>
      <ReceptionView
        navigationPaths={{
          future: "/building/visitors/preregistrations",
          new: "/building/visitors/preregistrations/new",
        }}
        isLoadingVisitors={isLoadingBuildingVisitors}
        isLoadingPreregistrations={isLoadingPreregistrations}
        visitors={visitors}
        preregistrationGroups={preregistrationGroups ?? []}
      />
    </>
  );
}
